import { render, staticRenderFns } from "./BlockedEmailList.vue?vue&type=template&id=4908ac98&lang=pug"
import script from "./BlockedEmailList.vue?vue&type=script&lang=js"
export * from "./BlockedEmailList.vue?vue&type=script&lang=js"
import style0 from "./BlockedEmailList.vue?vue&type=style&index=0&id=4908ac98&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports